import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getSpecialRequestList(params) {
  return request({
    url: URL.partner.specialRequest,
    method: 'get',
    params
  })
}

export function saveSpecialRequest(data) {
  return request({
    url: URL.partner.specialRequest,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delSpecialRequest(uuid) {
  return request({
    url: URL.partner.specialRequest + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
